<template>
  <!-- Scrolling container for contentPane -->
  <div class="p-4">
    <template v-if="personData">
      <div class="hidden sm:flex pb-4 md:flex md:items-center md:justify-between md:space-x-5">
        <div class="flex items-start space-x-5">
          <div class="pt-1.5">
            <h1 class="text-2xl font-bold text-gray-900">{{ personData.name }}</h1>
          </div>
        </div>
      </div>

      <div class="flex-auto flex-row">
        <div class="flex flex-col">
          <div v-if="countryRoles.length != 0">
            <div class="flex flex-row bg-white px-4 py-5 border-b border-gray-200 rounded-t-md sm:px-6">
              <svg class="mr-2 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" viewBox="0 0 24 24" stroke="none" fill="currentColor">
                <path class="heroicon-ui" d="M4.06 13a8 8 0 0 0 5.18 6.51A18.5 18.5 0 0 1 8.02 13H4.06zm0-2h3.96a18.5 18.5 0 0 1 1.22-6.51A8 8 0 0 0 4.06 11zm15.88 0a8 8 0 0 0-5.18-6.51A18.5 18.5 0 0 1 15.98 11h3.96zm0 2h-3.96a18.5 18.5 0 0 1-1.22 6.51A8 8 0 0 0 19.94 13zm-9.92 0c.16 3.95 1.23 7 1.98 7s1.82-3.05 1.98-7h-3.96zm0-2h3.96c-.16-3.95-1.23-7-1.98-7s-1.82 3.05-1.98 7zM12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"/>
              </svg>
              <h3 class="text-lg leading-6 font-medium text-gray-900">Country Roles</h3>
            </div>  
            <div class="bg-white shadow overflow-hidden sm:rounded-b-md">
                <ul role="list" class="divide-y divide-gray-200">
                  <li v-for="role in countryRoles" :key="role.id">
                    <person-role-component :roleData="role"> </person-role-component>
                  </li>
                </ul>
            </div>
          </div>

          <div v-if="trainingCenterRoles.length != 0">
            <div class="flex flex-row bg-white px-4 py-5 border-b border-gray-200 rounded-t-md sm:px-6" :class="setMargin">
              <svg class="mr-2 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" stroke="none" fill="currentColor" viewBox="0 0 24 24">
                <polygon points="15.52 14.78 14.06 16.14 12 13.92 9.94 16.14 8.48 14.78 11 12.07 11 8.64 13 8.64 13 12.07 15.52 14.78"/><path d="M12,8.28a3.83,3.83,0,1,1,3.82-3.82A3.83,3.83,0,0,1,12,8.28Zm0-5.65a1.83,1.83,0,1,0,1.82,1.83A1.82,1.82,0,0,0,12,2.63Z"/><path d="M6.35,22.66a3.83,3.83,0,1,1,3.83-3.83A3.83,3.83,0,0,1,6.35,22.66Zm0-5.65a1.83,1.83,0,1,0,1.83,1.82A1.82,1.82,0,0,0,6.35,17Z"/><path d="M17.65,22.66a3.83,3.83,0,1,1,3.82-3.83A3.84,3.84,0,0,1,17.65,22.66Zm0-5.65a1.83,1.83,0,1,0,1.82,1.82A1.83,1.83,0,0,0,17.65,17Z"/>
              </svg>
              <h3 class="text-lg leading-6 font-medium text-gray-900">Training Center Roles</h3>
            </div>  
            <div class="bg-white shadow overflow-hidden sm:rounded-b-md">
                <ul role="list" class="divide-y divide-gray-200">
                  <li v-for="role in trainingCenterRoles" :key="role.id">
                    <person-role-component :roleData="role"> </person-role-component>
                  </li>
                </ul>
            </div>
          </div>
        </div>

        <!-- <gen-tree-component :genTreeData="treeData"> </gen-tree-component> -->
      </div>

      <div class="flex flex-row bg-white px-4 py-5 mt-4 border-b border-gray-200 rounded-t-md sm:px-6">
        <svg class="mr-2 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150 <%= current_class?(users_path)%>" xmlns="http://www.w3.org/2000/svg" stroke="none" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <path class="heroicon-ui" d="M12 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm9 11a1 1 0 0 1-2 0v-2a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v2a1 1 0 0 1-2 0v-2a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v2z"/>
        </svg>
        <h3 class="text-lg leading-6 font-medium text-gray-900">User Information</h3>
      </div> 
      <div class="bg-white shadow overflow-hidden sm:rounded-b-md">
        <div v-if="userData" class="px-4 py-4 sm:px-6">
          <div class="pb-2"> Name: {{ userData.first_name + ' ' + userData.last_name }} </div>
          <div class="pb-2"> Created at: {{ userData.created_at }} </div>

          <ul role="list" class="divide-y divide-gray-200">
            <li v-for="role in userRoles" :key="role.id">
              <user-role-component :roleData="role"> </user-role-component>
            </li>
          </ul>
        </div>
        <div v-else class="px-4 py-4 sm:px-6">
          No User Info
        </div>
      </div>
    </template>
    <template v-else>
      No Data
    </template>
  </div>
</template>

<script>
  import PersonRoleComponent from '@components/person_linkage_system/PersonRoleComponent'
  import UserRoleComponent from '@components/person_linkage_system/UserRoleComponent'
  // import GenTreeComponent from '@components/person_linkage_system/GenTreeComponent'

  export default {
    name: '',
    components: {
      PersonRoleComponent,
      UserRoleComponent,
      // GenTreeComponent,
    },
    data () {
      return {
      }
    },
    created () {
    },
    updated () {
      // this.buildSimplifiedGenTree()
    },
    mounted () {
    },
    computed: {
      personDataChanged () {
        return this.personData
      },
      trainingCenterRoles () {
        return this.personData.relationships.person_roles.filter(role => role.relatable_type == 'TrainingCenter')
      },
      countryRoles () {
        return this.personData.relationships.person_roles.filter(role => role.relatable_type == 'Country')
      },
      userRoles () {
        return this.personData.relationships.user.relationships.user_roles
      },
      userData () {
        return this.personData.relationships.user ? this.personData.relationships.user : null
      },
      setMargin () {
        return this.countryRoles.length != 0 ? 'mt-4' : ''
      },
    },
    methods: {
    },
    props: {
      personData: {
        type: Object,
      },
      treeData: {
        type: Object,
      }
    },
  }
</script>

<style lang="scss">
</style>
